/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Subtitle_Imported_MessageInputs */

const en_iframe_remote_subtitle_imported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Imported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle file imported successfully`)
};

const fr_iframe_remote_subtitle_imported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Imported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier de sous-titres importe avec succes`)
};

const de_iframe_remote_subtitle_imported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Imported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertiteldatei erfolgreich importiert`)
};

const it_iframe_remote_subtitle_imported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Imported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File dei sottotitoli importato correttamente`)
};

const ru_iframe_remote_subtitle_imported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Imported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл субтитров успешно импортирован.`)
};

const es_iframe_remote_subtitle_imported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Imported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo de subtítulos importado exitosamente`)
};

const zh_cn2_iframe_remote_subtitle_imported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Imported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕文件导入成功`)
};

const ja_iframe_remote_subtitle_imported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Imported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕ファイルが正常にインポートされました`)
};

const hi_iframe_remote_subtitle_imported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Imported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक फ़ाइल सफलतापूर्वक आयात हो गई`)
};

const pt_pt2_iframe_remote_subtitle_imported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Imported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de legendas importado com sucesso.`)
};

/**
* | output |
* | --- |
* | "Subtitle file imported successfully" |
*
* @param {Iframe_Remote_Subtitle_Imported_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_imported_message = /** @type {((inputs?: Iframe_Remote_Subtitle_Imported_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_Imported_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_subtitle_imported_message(inputs)
	if (locale === "de") return de_iframe_remote_subtitle_imported_message(inputs)
	if (locale === "it") return it_iframe_remote_subtitle_imported_message(inputs)
	if (locale === "ru") return ru_iframe_remote_subtitle_imported_message(inputs)
	if (locale === "es") return es_iframe_remote_subtitle_imported_message(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_subtitle_imported_message(inputs)
	if (locale === "ja") return ja_iframe_remote_subtitle_imported_message(inputs)
	if (locale === "hi") return hi_iframe_remote_subtitle_imported_message(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_subtitle_imported_message(inputs)
	return en_iframe_remote_subtitle_imported_message(inputs)
});